import { makeStyles } from "@material-ui/core";

export const loadsDashboardStyles = makeStyles((theme) => ({
    widgetWrapper: {
        boxShadow: '2px 3px 10px #d7d6d6',
        paddingBottom: '0.5rem',
        height: '100%',

    },
    widgetWrapperBig: {
        height: '100%',
        paddingBottom: '1rem'
    },
    filtersWrapper: {
        display: 'flex',
        alignItems: 'center',
        padding: '1rem',
    },
    filterItem: {
        marginRight: '0.5rem'
    },
}));